<template>
    <Path>
        <template v-slot:path>
            <li>
                <router-link :to="{ name: 'dashboard' }">الصفحة الرئيسية</router-link>
            </li>
            <li> <span class="divider"> / </span><a href="#services"
                    @click="$router.push({ name: 'dashboard' })">الخدمات
                </a> </li>
            <li> <span class="divider"> / </span>
                <router-link :to="{ name: 'translatedservices' }">الخدمات المترجمة</router-link>
            </li>
            <li> <span class="divider"> / </span><a href="#"> استخراج شهادة ميلاد مترجمه </a> </li>
        </template>
    </Path>

    <section v-if="!isReview" id="content">
        <div class="py-5 ">
            <div class="container">
                <div class="row">
                    <div class="col-12 mb-2">
                        <h2 class="blueFont ">الطلب {{ docRequests.totalRequests }} / {{ docRequests.requestNo }} شهادة
                            ميلاد مترجمه</h2>
                    </div>
                    <div class="col-md-6 offset-md-6 mb-3">
                        <div class="form-check form-switch">
                            <input v-model="checked" class="form-check-input  shadow-sm" type="checkbox" role="switch"
                                id="flexSwitchCheckDefault">
                            <label class="form-check-label" for="flexSwitchCheckDefault">اصدار شهادة ميلاد لنفسك</label>
                        </div>

                    </div>
                </div>

                <div class="row mb-3">
                    <div class="col-md-6">
                        <label for="basic-url" class="form-label">الاسم رباعي لصاحب الشهادة</label>
                        <div class="input-group mb-3">
                            <div class="row g-3">
                                <div class="col-6 col-sm">
                                    <input v-model="form.firstName" type="text" class="form-control" id="basic-url1"
                                        aria-describedby="basic-addon3" @blur="v$.form.firstName.$touch()">
                                    <p class="data--required" v-for="error of v$.form.firstName.$errors"
                                        :key="error.$uid">
                                        {{ error.$message }}
                                    </p>
                                </div>
                                <div class="col-6 col-sm">
                                    <input v-model="form.secondName" type="text" class="form-control" id="basic-url2"
                                        aria-describedby="basic-addon3" @blur="v$.form.secondName.$touch()">
                                    <p class="data--required" v-for="error of v$.form.secondName.$errors"
                                        :key="error.$uid">
                                        {{ error.$message }}
                                    </p>
                                </div>
                                <div class="col-6 col-sm">
                                    <input v-model="form.thirdName" type="text" class="form-control" id="basic-url3"
                                        aria-describedby="basic-addon3" @blur="v$.form.thirdName.$touch()">
                                    <p class="data--required" v-for="error of v$.form.thirdName.$errors"
                                        :key="error.$uid">
                                        {{ error.$message }}
                                    </p>
                                </div>
                                <div class="col-6 col-sm">
                                    <input v-model="form.fourthName" type="text" class="form-control" id="basic-ur4l"
                                        aria-describedby="basic-addon3" @blur="v$.form.fourthName.$touch()">
                                    <p class="data--required" v-for="error of v$.form.fourthName.$errors"
                                        :key="error.$uid">
                                        {{ error.$message }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <label for="basic-url" class="form-label">الرقم القومى لصاحب الشهادة</label>
                        <div class="input-group mb-3">
                            <div class="col-md-12">
                                <input v-model="form.nid" type="text" class="form-control" id="basic-url1"
                                    aria-describedby="basic-addon3" @blur="v$.form.nid.$touch()">
                                <p class="data--required" v-for="error of v$.form.nid.$errors" :key="error.$uid">
                                    {{ error.$message }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row mb-3">
                    <div class="col-md-6">
                        <label for="" class="form-label">النوع</label>
                        <div class="input-group mb-3">
                            <div class="col-md-12">
                                <select v-model="gender" class="form-select" id="basic-url1"
                                    aria-describedby="basic-addon3" @blur="v$.gender.$touch()">
                                    <option v-for="gender in gender_lookups" :key="gender.Id" :value="gender.Code">
                                        {{ gender.Name }}</option>
                                </select>
                                <p class="data--required" v-for="error of v$.gender.$errors" :key="error.$uid">
                                    {{ error.$message }}
                                </p>
                            </div>
                        </div>
                    </div>


                    <div v-if="checked === false" class="col-md-6">
                        <label for="" class="form-label">صلة القرابة</label>
                        <div class="input-group mb-3">
                            <div class="col-md-12">
                                <select v-model="form.relationCode" class="form-select" id="basic-url1"
                                    aria-describedby="basic-addon3" @blur="v$.relationCode.$touch()">
                                    <option v-for="relation in relation_lookups" :key="relation.Id"
                                        :value="relation.Code">
                                        {{ relation.Name }}</option>
                                </select>
                                <p class="data--required" v-for="error of v$.relationCode.$errors" :key="error.$uid">
                                    {{ error.$message }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row mb-3">
                    <div class="col-md-6">
                        <label for="" class="form-label">اسم الام الاول لصاحب الشهادة</label>
                        <div class="input-group mb-3">
                            <div class="col-md-12">
                                <input v-model="form.motherName" type="text" class="form-control " id="basic-ur4l"
                                    aria-describedby="basic-addon3" @blur="v$.form.motherName.$touch()">
                                <p class="data--required" v-for="error of v$.form.motherName.$errors" :key="error.$uid">
                                    {{ error.$message }}
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-6">
                        <label for="" class="form-label">اللغة</label>
                        <div class="input-group mb-3">
                            <div class="col-md-12">
                                <select v-model="form.languageCode" class="form-select" id="basic-url1"
                                    aria-describedby="basic-addon3" @blur="v$.form.languageCode.$touch()">
                                    <option v-for="lang in language_lookups" :key="lang.Id" :value="lang.Code">
                                        {{ lang.Name }}
                                    </option>
                                </select>
                                <p class="data--required" v-for="error of v$.form.languageCode.$errors"
                                    :key="error.$uid">
                                    {{ error.$message }}
                                </p>
                            </div>

                        </div>
                    </div>

                </div>

                <div class="row mb-3">
                    <div class="col-6 col-md-2">
                        <label for="" class="form-label mb-3">عدد النسخ</label>
                    </div>
                    <div class="col-6 col-md-4  mb-3 counter_input">
                        <button @click="copies++" type="button" class="pa-0  ma-0  icon-btn"><i
                                class="bi bi-plus-circle"></i></button>
                        <input v-model="copies" type="text" class="form-control  text-center" aria-label="">
                        <button @click="copies--" type="button" class="pa-0 ma-0 icon-btn"><i
                                class="bi bi-dash-circle"></i></button>
                    </div>

                    <div class="col-6 col-md-3 mb-3">
                        <label for="" class="form-label">اجمالى سعر الخدمة</label>
                    </div>
                    <div class="col-6 col-md-3 mb-3">
                        <input v-model="totalPrice" type="text" readonly="readonly" class="form-control text-center"
                            aria-label="">
                    </div>
                </div>

                <div class="row">
                    <div class="row my-5 justify-content-center">

                        <div :hidden="docRequests.requestNo === 1" class="col-6 col-sm-2 mb-3">
                            <div class="d-flex justify-content-center">
                                <button @click="previousDoc" type="button"
                                    class="btn1 btn-light mx-3 align-self-center">
                                    الشهادة السابقة
                                </button>
                            </div>
                        </div>

                        <div :hidden="docRequests.totalRequests === docRequests.requestNo" class="col-6 col-sm-2 mb-3 ">
                            <div class="d-flex justify-content-center">
                                <button @click="nextDoc" type="button" class="btn1 btn-light mx-3 align-self-center">
                                    الشهادة التالية
                                </button>
                            </div>
                        </div>

                        <div :hidden="docRequests.totalRequests !== docRequests.requestNo" class="col-6 col-sm-2 mb-3">
                            <div class="d-flex justify-content-center">
                                <button @click="addBirthDoc" type="button"
                                    class="btn1 btn-light mx-3 align-self-center">
                                    إضافة شهادة
                                </button>
                            </div>
                        </div>

                        <div :hidden="docRequests.requestNo === 1" class="col-6 col-sm-2 mb-3">
                            <div class="d-flex justify-content-center">
                                <button @click="deleteDocument" type="button"
                                    class="btn1 btn-light mx-3 align-self-center">
                                    حذف شهادة
                                </button>
                            </div>
                        </div>

                        <div class="col-6 col-sm-2 mb-3 ">
                            <div class="d-flex justify-content-center">
                                <button @click="review_request" type="button"
                                    class="btn1 btn-light mx-3 align-self-center">
                                    مراجعة الطلب
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <Review v-if="isReview" @close="toggle_isReview()" :serviceprice="price" :DocCode="BirthCode"
        DocType="شهادة ميلاد مترجمة" :DocData="DocData" :isNid="false" />

</template>


<script>
import { helpers, requiredIf } from "@vuelidate/validators";
import validations from "@/shared/validations.js";
import { mapActions, mapGetters } from "vuex";
import useVuelidate from "@vuelidate/core";
import Path from "@/components/Path.vue";
import Review from "@/components/Review.vue";
import { ref } from 'vue';
import sharedMethods from "@/shared/sharedMethods";
import sharedData from '@/shared/sharedData';
import { debugLog } from "@/plugins/debug";

export default {
    ...sharedMethods,
    name: 'TBirthView',
    components: { Path, Review },
    data() {
        return {

            v$: useVuelidate(),

            valid: false,
            count: 0,
            docsCount: 1,
            checked: false,
            totalPrice: 0,
            price: 0,

            responseMessage: '',
            responseCode: 200,

            // # document requests
            docRequests: {
                requestNo: 1,
                totalRequests: 1
            },

            relation_lookups: [],
            gender_lookups: [],
            language_lookups: sharedData.language_lookups,

            BirthCode: sharedData.DocumentsCode.BirthCode,
            TranslatedCode: sharedData.DocumentsCode.TranslatedCode,
            gender: '',
            copies: 1,

            form: {
                firstName: '',
                secondName: '',
                thirdName: '',
                fourthName: '',
                nid: '',
                motherName: '',
                relationCode: '',
                languageCode: Number
            },
        }
    },
    setup() {
        const isReview = ref(false);

        const toggle_isReview = () => {
            isReview.value = !isReview.value;

        }
        return { isReview, toggle_isReview }
    },

    // validations
    validations() {
        return {
            relationCode: { requiredIf: helpers.withMessage("*", requiredIf(!this.checked)), $autoDirty: true },
            ...validations.TBirth
        }
    },

    created() {
        // reset after refersh or reloading page
        this.resetDocs();  // store action for resetting number of documents in store to 0
        this.docRequests.requestNo = 1;
        setTimeout(() => {
            sharedMethods.get_servicePrice("translatedDocPrice").then(res => { this.price = res; this.totalPrice = res; });
            sharedMethods.get_genders().then(res => { this.gender_lookups = res; });
        }, 200);
        
        //   this.AutoFill();
    },
    watch: {
        // whenever gender changes, this function will run
        gender(newGender) {
            if (newGender) {
                sharedMethods.get_relations(this.TranslatedCode, this.gender).then(res => { this.relation_lookups = res; });
            }
        },
        copies(newCopy) {
            this.totalPrice = this.price * newCopy;
            if (newCopy > 5) {
                this.copies = 5;
            }
            if (newCopy <= 1) {
                this.copies = 1;
            }
        },
    },

    computed: {
        ...mapGetters({ BirthDocs: "StateDocs", options: "StateOptions", docsCheck: "StateBirthDocsChecked", contactInfo: "StateContact" }),

        relationCode() {
            return this.checked ? 'SELF' : this.form.relationCode
        },

        DocData() {
            debugLog('Contact Info:',this.$store.state);
            return {
                "translatedDocs": Object.values(this.BirthDocs),
                ...this.contactInfo
            }
        },
    },

    methods: {
        ...mapActions(["saveDocs", "resetDocs", "deleteDoc"]),

        async review_request() {
            this.v$.$validate();
            if (!this.v$.$error) {
                this.saveDocument(); // save form data first in the store  
                debugLog('DOC DATA:', this.DocData);
                await sharedMethods.PreviewDoc(this.DocData, this.options).then(res => { this.responseCode = res.responseCode; this.responseMessage = res.responseMessage; });
                if (this.responseCode === 200) {

                    debugLog('Docs:', Object.values(this.BirthDocs));

                    this.isReview = true;
                } else {
                    this.$alerts.toast.error(this.responseMessage);
                }

            } else {
                this.$alerts.toast.error('هناك خطأ فى البيانات المدخلة');
            }
        },

        // add new birth document
        async addBirthDoc() {
            this.v$.$validate();
            if (!this.v$.$error) {
                this.saveDocument(); // save form data first in the store
                await sharedMethods.PreviewDoc(this.DocData, this.options).then(res => { this.responseCode = res.responseCode; this.responseMessage = res.responseMessage; });

                if (this.responseCode === 200) {

                    this.docRequests.totalRequests++;
                    this.docRequests.requestNo++;
                    this.docsCount++;

                    this.reset();
                } else {
                    this.$alerts.toast.error(this.responseMessage);
                }
            } else {
                this.$alerts.toast.error('هناك خطأ فى البيانات المدخلة');
            }
        },

        // go to previous document
        async previousDoc() {
            this.v$.$validate();
            if (!this.v$.$error) {
                this.saveDocument(); // save form data first in the store
                await sharedMethods.PreviewDoc(this.DocData, this.options).then(res => { this.responseCode = res.responseCode; this.responseMessage = res.responseMessage; });

                if (this.responseCode === 200) {
                    this.reset();

                    if (this.docRequests.requestNo > 1) {
                        this.docRequests.requestNo--;
                        this.docsCount--;
                    }
                    this.checked = this.docsCheck[this.docRequests.requestNo];

                    this.fillData();
                } else {
                    this.$alerts.toast.error(this.responseMessage);
                }
            } else {
                this.$alerts.toast.error('هناك خطأ فى البيانات المدخلة');
            }
        },

        // go to next document
        async nextDoc() {
            this.v$.$validate();
            if (!this.v$.$error) {
                this.saveDocument(); // save form data first in the store
                await sharedMethods.PreviewDoc(this.DocData, this.options).then(res => { this.responseCode = res.responseCode; this.responseMessage = res.responseMessage; });
                if (this.responseCode === 200) {
                    this.reset();
                    if (this.docRequests.requestNo < this.docRequests.totalRequests) {
                        this.docRequests.requestNo++;
                        this.docsCount++;
                    }
                    this.checked = this.docsCheck[this.docRequests.requestNo];
                    this.fillData();
                } else {
                    this.$alerts.toast.error(this.responseMessage);
                }
            } else {
                this.$alerts.toast.error('هناك خطأ فى البيانات المدخلة');
            }
        },

        // Delete document
        deleteDocument() {

            if (this.docRequests.requestNo > 1) {
                this.deleteDoc(this.docRequests.requestNo);
                this.docRequests.totalRequests--;
                this.docRequests.requestNo--;
                this.docsCount--;
            }
            this.checked = this.docsCheck[this.docRequests.requestNo];

            this.fillData();
        },

        //auto fill for testing
        AutoFill() {
            this.form.firstName = "تسنيم";
            this.form.secondName = "سمير";
            this.form.thirdName = "محمد";
            this.form.fourthName = "شحاتة";
            this.form.motherName = "ماما";
            this.form.nid = "29709011235741";
            this.form.gender = 'M';
            this.copies = 1;

        },

        // fill data in the form in case of already existing docs
        fillData() {

            if (this.BirthDocs[this.docRequests.requestNo]) {

                let fullname = (this.BirthDocs[this.docRequests.requestNo]).name.fullName.split(' ');

                this.form.firstName = fullname[0];
                this.form.secondName = fullname[1];
                this.form.thirdName = fullname[2];
                this.form.fourthName = fullname[3];
                this.form.motherName = (this.BirthDocs[this.docRequests.requestNo]).motherFullName;
                this.form.nid = (this.BirthDocs[this.docRequests.requestNo]).nid.nationalIdenNumber;
                this.form.relationCode = (this.BirthDocs[this.docRequests.requestNo]).relationCode;
                this.gender = (this.BirthDocs[this.docRequests.requestNo]).genderCode;
                this.form.languageCode = (this.BirthDocs[this.docRequests.requestNo]).languageCode;
                this.copies = (this.BirthDocs[this.docRequests.requestNo]).numberOfCopies;

            }

        },

        // assign data to variables and save it to the store
        saveDocument() {
            let docData = {
                "numberOfCopies": parseInt(this.copies),
                "name": { "fullName": this.form.firstName + ' ' + this.form.secondName + ' ' + this.form.thirdName + ' ' + this.form.fourthName },
                "motherFullName": this.form.motherName,
                "spouseFullName": '',
                "genderCode": this.gender,
                "nid": { "nationalIdenNumber": this.form.nid },
                "relationCode": this.relationCode,
                "languageCode": this.form.languageCode,
                "documentTypeCode": this.BirthCode,
            }
            let savedata = {
                "reqNo": this.docRequests.requestNo,
                "document": docData,
                "checked": this.checked
            }


            this.saveDocs(savedata);  // store action for saving Documents

        },

        // empty form data to fill new one
        reset() {
            this.form = {};
            this.copies = 1;
            this.checked = false;
            this.gender = '',
                this.relation_lookups = [],
                this.v$.$reset();
        }
    }
}
</script>
